export const getLanguage = () => {
    return (global.navigator && global.navigator.language.slice(0, 2)) || 'ko';
}

export const formatDate = d => {
    return new Date(d).toLocaleDateString(getLanguage(), {dateStyle: 'medium'})
}

export const yearMonthFormatter = new Intl.DateTimeFormat(getLanguage(), {year: 'numeric', month: 'short'});

export const formatYearMonth = ym => {
    let y = ym.slice(0, 4);
    let m = ym.slice(4, 6) - 1;
    let date = new Date(y, m, 1);
    return yearMonthFormatter.format(date);
};
